import { render } from "./MedicoCreate.vue?vue&type=template&id=30bab518&scoped=true"
import script from "./MedicoCreate.vue?vue&type=script&lang=js"
export * from "./MedicoCreate.vue?vue&type=script&lang=js"

import "./MedicoCreate.vue?vue&type=style&index=0&id=30bab518&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bab518"]])

export default __exports__